/**
 * Storage Utility Functions
 * Centralized storage operations for security and maintainability
 */

/**
 * Safely clears all authentication-related storage
 * Centralizes storage cleanup to reduce duplication and improve security
 */
export const clearAuthStorage = () => {
  try {
    // Remove specific authentication items
    localStorage.removeItem('accessToken');
    localStorage.removeItem('clientId');
    localStorage.removeItem('userOid');
    localStorage.removeItem('userTid');
    
    // Clear all session storage
    sessionStorage.clear();
    
    // Clear all localStorage (be careful with this in production)
    localStorage.clear();
    
    console.log('Authentication storage cleared successfully');
  } catch (error) {
    console.error('Error clearing authentication storage:', error);
  }
};

/**
 * Safely gets an item from localStorage with error handling
 * @param {string} key - The key to retrieve
 * @returns {string|null} The stored value or null
 */
export const safeGetLocalStorage = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    console.error(`Error getting localStorage item ${key}:`, error);
    return null;
  }
};

/**
 * Safely sets an item in localStorage with error handling
 * @param {string} key - The key to set
 * @param {string} value - The value to store
 * @returns {boolean} Success status
 */
export const safeSetLocalStorage = (key, value) => {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (error) {
    console.error(`Error setting localStorage item ${key}:`, error);
    return false;
  }
};

/**
 * Safely removes an item from localStorage with error handling
 * @param {string} key - The key to remove
 * @returns {boolean} Success status
 */
export const safeRemoveLocalStorage = (key) => {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (error) {
    console.error(`Error removing localStorage item ${key}:`, error);
    return false;
  }
};

/**
 * Safely gets an item from sessionStorage with error handling
 * @param {string} key - The key to retrieve
 * @returns {string|null} The stored value or null
 */
export const safeGetSessionStorage = (key) => {
  try {
    return sessionStorage.getItem(key);
  } catch (error) {
    console.error(`Error getting sessionStorage item ${key}:`, error);
    return null;
  }
};

/**
 * Safely sets an item in sessionStorage with error handling
 * @param {string} key - The key to set
 * @param {string} value - The value to store
 * @returns {boolean} Success status
 */
export const safeSetSessionStorage = (key, value) => {
  try {
    sessionStorage.setItem(key, value);
    return true;
  } catch (error) {
    console.error(`Error setting sessionStorage item ${key}:`, error);
    return false;
  }
};